<template>
  <div ref="layout" class="page-form">
    <h3 class="title">货权转移申请单</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button style="margin-right: 10px" @click="$router.go(-1)">返回</form-button>
        <btky-header
          :form-data="transferApplyPo"
          :process-key="processKey"
          @formDataSave="saveData"
          @validate="validate"
          @startflow="startflow"
          @advanceSuccess="advanceSuccess"
        />
      </div>
      <CommonTitle title="基本信息" />
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :show-message="false"
        :model="transferApplyPo"
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="transferApplyPo.createdByName"
                placeholder="请输入"
                type="text"
                name="transferApplyPo.createdByName"
                clearable
                readonly
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="transferApplyPo.createdDate"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="接收客户" prop="receiveClientCode">
              <wly-input
                v-model="transferApplyPo.receiveClientCode"
                input-type="customer"
                :query-params="{mode: 'HQZY'}"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="showClientDialog"
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="接收客户名称">
              <el-input v-model="transferApplyPo.receiveClient" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="转移明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template #thisTransferQuantity="{ row }">
            <el-input v-model="row.thisTransferQuantity" size="mini" type="number" />
          </template>
          <template #planType="{ row }">
            <span>{{ filterDictionary(row.planType, 'A0002') }}</span>
          </template>
          <template #comment="{ row }">
            <el-input v-model="row.comment" size="mini" type="text" />
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"

          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!--选择客户-->
    <el-dialog v-dialogDrag title="接收客户选择" :visible.sync="clientDialog" width="80%" :append-to-body="true">
      <div class="dialog-content" style="padding: 10px;">
        <QueryParams ref="clientQueryParams" :loading="clientLoading" :search-field="clientSearchField" @search="queryReceiveCustomers" />
        <div class="table-container" style="padding: 10px;">
          <Table-filter
            title="明细"
            :rt-columns="clientRtColumns1"
            :lt-columns="clientLtColumns1"
            :grid-columns="clientGridOptions.columns"
            :count-data="clientCountFileds"
            :all-options="clientAllOptions"
            :pagination="clientPagination"
            @pagination-change="handleClientTablePaginationChange"
            @confirm="clientTableConfigConfirm"
          >
            <vxe-grid
              ref="clientTable"
              v-loading="clientLoading"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              height="300"
              max-height="500"
              align="center"
              size="mini"
              show-overflow
              :sort-config="{ multiple: true }"
              :empty-render="{name: 'NotData'}"
              :radio-config="{ highlight: true }"
              :toolbar-config="{ custom: true, size: 'mini' }"
              :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="clientGridOptions.columns"
              :data="clientGridOptions.data"
              :row-class-name="clientRowClassName"
              @filter-change="clientFilterChangeEvt"
            >
            </vxe-grid>
          </Table-filter>
        </div>
      </div>
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="clientDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmSelect"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { handlerFlow, generateUUID } from '@/api/flowHander'
import { filterDictionary } from '@/utils/index'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { webUploadFile, deleteFiles, queryFiles, apiAttachmentDownFile } from '@/api/common'
import { transfergoodsrightsFindById, findReceiveCustomersByTransferCustomer } from '@/api/applyForGoods/index'
import { download } from '@/utils/frontExport'
import { apiSapSingleClientInfo } from '@/api/common'
import tableMixins from '@/utils/tableMixins'
import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export default {
  mixins: [tableMixins],
  components: {
    ClientSelect
  },
  data() {
    const rules = {
      invoiceNo: [{ required: false, message: '请选择制票通知单', trigger: 'change' }],
      planType: [{ required: false, message: '请选择计划类型', trigger: 'change' }],
      planYear: [{ required: false, message: '请选择计划年度', trigger: 'change' }],
      receiveClientCode: [{ required: true, message: '请选择货权接收客户', trigger: 'blur' }],
      receiveClient: [{ required: true, message: '请选择货权接收客户', trigger: 'change' }],
      //  receiveClientCode: [{ required: true, message: '请选择货权接收客户', trigger: 'change' }],
      //  receiveClient: [{ required: true, message: '请选择货权接收客户', trigger: 'change' }],
      thisTransferQuantity: [{ required: true, message: '请填写本次转移量', trigger: 'blur' }]
    }
    return {
      form: {},
      errorList: [],
      disableInvoice: true,
      rules: rules,
      pagination: {
        page: 1,
        pagesize: 100,
        totalCount: 0
      },
      processKey: 'transfergoodsrights',
      clientDialog: false,
      clientLoading: false,
      clientPagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      clientGridOptions: {
        columns: [
          { type: 'radio', title: '', width: 50, field: 'radio' },
          { field: 'receiveCustomerCode', title: '接收客户编码', width: 150 },
          { field: 'receiveCustomerName', title: '接收客户名称', width: 200 },
          { field: 'customerTypeTextView', title: '客户类型', width: 120 },
          { field: 'saleCenterTextView', title: '营销单元', width: 200 },
          { field: 'baseName', title: '基地', width: 150 }
        ],
        data: []
      },
      clientSearchField: {
        receiveCustomerCode: {
          title: '接收客户编码',
          type: 'input',
          equation: all,
          width: 170
        },
        receiveCustomerName: {
          title: '接收客户名称',
          type: 'input',
          equation: all,
          width: 250
        },
        customerType: {
          title: '客户类型',
          type: 'select',
          equation: all,
          dictionary: 'A0009',
          width: 150
        },
        saleCenter: {
          title: '营销单元',
          type: 'select',
          equation: all,
          dictionary: 'sale',
          width: 200
        }
      },
      clientRtColumns1: [
        { title: '显示列', field: 'title' }
      ],
      clientLtColumns1: [
        { title: '所有列', field: 'title' }
      ],
      clientCountFileds: [],
      clientAllOptions: {},
      selectDataOptions: {},
      clientRanges: {},
      clientAllConditions: {},
      clientCalculation: null,
      clientTableCountData: [],
      clientShowHeader: false,
      clientFilterList: [],
      clientSortData: [],
      transferApplyPo: {
        id: '',
        taskId: '',
        bizCode: 'transfergoodsrights',
        bizId: '',
        status: 0,
        billCode: '',
        billStatus: 'E001',
        deptId: '',
        deptName: '',
        endDate: '',
        expireDate: '',
        fillinDate: '',
        fullId: '',
        organId: '',
        organName: '',
        personMemberId: '',
        personMemberName: '',
        fileBizId: '',
        positionId: '',
        positionName: '',
        createdById: '',
        createdByName: '',
        createdDate: '',
        invoiceNo: '',
        transferClient: '',
        receiveClient: '',
        receiveClientCode: '',
        productCode: '',
        productDesc: '',
        invoiceQuantity: '',
        deliveryQuantity: '',
        transferedQuantity: '',
        thisTransferQuantity: '',
        planType: '',
        planYear: ''
      },
      gridOptions: {
        columns: [
          { field: 'transferSourceId', title: '转移单ID', width: 120, visible: false },
          { field: 'planYear', title: '年度', width: 80 },
          { field: 'orderCust', title: '来源客户', width: 120 },
          { field: 'orderCustName', title: '来源客户名称', width: 200 },
          { field: 'planType', title: '计划类型', width: 120, slots: { default: 'planType' }},
          { field: 'productDesc', title: '产品名称', width: 200 },
          { field: 'transferedQuantity', title: '已转移量', width: 90 },
          { field: 'surplusQty', title: '剩余量', width: 80 },
          {
            field: 'thisTransferQuantity',
            title: '*本次货权转移量',
            width: 120,
            slots: { default: 'thisTransferQuantity' }
          },
          { field: 'comment', title: '备注', width: 'auto', slots: { default: 'comment' }}
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'role'])
  },
  watch: {
    'gridOptions.data': {
      handler(val) {
        this.transferApplyPo.transferProductDtlList = val
      },
      deep: true
    }
  },
  created() {
    this.init()
    const { id } = this.$route.query
    if (id) {
      this.transferApplyPo.id = id
      this.transferApplyPo.bizId = id
      this.transfergoodsrightsFindById()
    } else {
      if (this.$route.params.rows?.length > 0) {
        const datas = []
        this.$route.params.rows.map(item => {
          const data = {
            transferSourceId: item.transferId,
            invoiceNo: item.invoInfoid,
            invoiceDetailId: item.ticketDetailId,
            planType: item.zZFLD00002Q,
            planYear: item.annual,
            custName: item.custName,
            orderCust: item.orderCust,
            orderCustName: item.orderCustName,
            productCode: item.productCode,
            productDesc: item.productDesc,
            invoiceQuantity: item.invoiceQty,
            deliveryQuantity: item.transferPayQty,
            transferedQuantity: item.totalTransfer,
            surplusQty: item.availableQty
          }
          datas.push(data)
        })
        this.gridOptions.data = datas
        this.getUserInfo()
      } else {
        this.$router.go(-1)
      }
      // 获取生成文件id
      generateUUID().then(res => {
        this.transferApplyPo.fileBizId = res.data
      })
    }
  },

  methods: {
    async searchCustome(e) {
      if (e.target.value) {
        const params = {
          partner: e.target.value
        }
        const res = await apiSapSingleClientInfo(params)
        if (res.msgtype === 'S') {
          this.transferApplyPo.receiveClientCode = res.data.info.partner
          this.transferApplyPo.receiveClient = res.data.info.name_org1
        }
      }
    },
    filterDictionary,
    startflow(data) {
      this.id = data.bizId
      this.transferApplyPo.id = data.bizId
      this.transferApplyPo.bizId = data.bizId
      this.transferApplyPo.taskId = data.taskId
      this.transferApplyPo.procInstId = data.bizprocInstId
      this.transferApplyPo.billCode = data.bizData.billCode
      this.transferApplyPo.billStatus = data.bizData.billStatus
      this.transferApplyPo.createdByName = data.bizData.createdByName
    },
    init() {
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
    },
    wlyHqzyPoJiHuaLeiXingChanged(value) {
      this.$set(this['wlyHqzyPo'], 'jiHuaLeiXing', value)
    },
    async transfergoodsrightsFindById() {
      const res = await transfergoodsrightsFindById({ id: this.transferApplyPo.id })
      Object.assign(this.transferApplyPo, res.data)
      this.transferApplyPo.planYear = res.data.planYear + ''
      this.gridOptions2.data = this.transferApplyPo.attachmentList
      this.gridOptions.data = this.transferApplyPo.transferProductDtlList
      this.transferApplyPo.taskId = this.$route.query.taskId
      this.getFiles()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 控件回车
    async handleEnter(e, type, data) {
      this.errorList = []
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      if (data.customerCode - 0 === this.role.USER_BP - 0) {
        this.errorList = ['货权转移接收客户不能是自己！']
        return
      }
      switch (type) {
        case 'customer':
          this.transferApplyPo.receiveClient = data.customerName
          this.transferApplyPo.receiveClientCode = data.customerCode
          break
      }
    },
    getUserInfo() {
      this.transferApplyPo.createdByName = this.role.login_user
      this.transferApplyPo.createdDate = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
    },
    showClientDialog(e) {
      this.clientDialog = true
      e.target.blur()
      // 打开弹框时查询接收客户列表
      this.$nextTick(() => {
        // 为 QueryParams 组件的 $parent (ElDialog) 设置 resetCount 方法
        if (this.$refs.clientQueryParams && this.$refs.clientQueryParams.$parent) {
          this.$refs.clientQueryParams.$parent.resetCount = this.resetCount
        }
        this.queryReceiveCustomers(1)
      })
    },
    // 查询接收客户列表
    async queryReceiveCustomers(page, ranges) {
      if (page === 1) {
        this.clientPagination.page = page
        if (ranges) {
          this.clientRanges = ranges
          this.handleClientRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        transferCustomerCode: this.role.USER_BP, // 转出客户编码为当前登录用户
        ...this.clientAllConditions,
        ...this.clientPagination,
        is_result: 1,
      }

      this.clientLoading = true
      try {
        const response = await findReceiveCustomersByTransferCustomer(params)
        const { data: { Rows, Total }, calculation, field } = response
        if (Rows.length === 0 && Total) {
          this.queryReceiveCustomers(1, ranges)
          return
        }
        this.clientPagination.totalCount = Total - 0
        // 检查 calculation 是否存在，避免 forEach 错误
        if (calculation && Array.isArray(calculation)) {
          this.clientCalculation = this.filtercalculation(calculation, 'clientTable', true)
        } else {
          this.clientCalculation = null
        }
        // 直接赋值数据，不使用计算行（因为初始 clientTableCountData 为空）
        this.$set(this.clientGridOptions, 'data', Rows || [])
        // 检查 field 是否存在
        if (field) {
          this.clientAllOptions = this.filterAllOptions(field, 'clientTable', true)
          // 使用 $nextTick 确保 DOM 更新后再设置过滤
          this.$nextTick(() => {
            this.setClientFilter()
          })
        }
      } catch (e) {
        console.error('查询接收客户失败:', e)
        this.$set(this.clientGridOptions, 'data', [])
      }
      this.clientLoading = false
    },
    // 处理客户查询条件
    handleClientRanges(ranges) {
      const allConditions = {}
      Object.keys(ranges).forEach(key => {
        if (ranges[key] && ranges[key].length > 0) {
          allConditions[key] = ranges[key]
        }
      })
      this.clientAllConditions = allConditions
    },
    // 客户表格分页变化
    handleClientTablePaginationChange(pages) {
      Object.assign(this.clientPagination, pages)
      this.queryReceiveCustomers()
    },
    // 客户表格配置确认
    clientTableConfigConfirm({ hiddenvalue, sortData, filters, countFileds, showHeader }) {
      if (hiddenvalue.length >= 1) {
        this.clientGridOptions.columns.forEach((item, idx) => {
          const index = hiddenvalue.findIndex(v => v.field === item.field)
          if (index < 0) {
            item.visible = false
          } else {
            item.visible = true
          }
        })
      } else {
        this.clientGridOptions.columns.forEach((item, idx) => {
          item.visible = true
        })
      }
      this.$refs.clientTable.loadColumn(this.clientGridOptions.columns)
      this.clientSortData = this.filedsort(sortData)
      const countList = countFileds.filter(v => v.count)
      this.clientCountFileds = countFileds
      const flag = !!this.clientTableCountData.length
      if (countList.length) {
        const data = {}
        countList.forEach(item => {
          data[item.field] = this.clientCalculation[item.field][item.count]
        })
        this.clientTableCountData = [data]
        this.clientShowHeader = showHeader
      } else {
        this.clientTableCountData = []
        this.clientShowHeader = false
      }
      this.$refs.clientTable.loadData(this.clientGridOptions.data)
    },
    // 客户表格行类名
    clientRowClassName({ rowIndex }) {
      if (this.clientTableCountData.length) {
        if (this.clientShowHeader) {
          if (rowIndex === 0) {
            return 'row-yellow'
          }
        } else {
          if (rowIndex === this.clientGridOptions.data.length - 1) {
            return 'row-yellow'
          }
        }
      }
    },
    // 客户表格过滤变化
    clientFilterChangeEvt({ column, property, values, datas, filterList }) {
      this.clientFilterList = filterList
      this.clientTableconfigFilters = {}
      filterList.forEach(item => {
        this.clientTableconfigFilters[item.field] = item.values
      })
      this.queryReceiveCustomers(1)
    },
    // 更新客户计算值
    updateClientCount() {
      if (this.clientTableCountData.length) {
        this.clientGridOptions.data.forEach((row, index) => {
          Object.keys(this.clientTableCountData[0]).forEach(key => {
            this.$set(row, key, this.clientTableCountData[0][key])
          })
        })
      }
    },
    // 设置客户过滤
    setClientFilter() {
      if (this.clientAllOptions && Object.keys(this.clientAllOptions).length) {
        this.clientGridOptions.columns.forEach(col => {
          if (this.clientAllOptions[col.field]) {
            col.filters = this.clientAllOptions[col.field].map(item => ({
              label: item,
              value: item
            }))
          }
        })
        this.$refs.clientTable.loadColumn(this.clientGridOptions.columns)
      }
    },
    // 重置计数（QueryParams 组件需要）
    resetCount() {
      // 空方法，QueryParams 组件会调用
    },
    // 选择客户
    async confirmSelect() {
      const selectedRow = this.$refs.clientTable.getRadioRecord()
      if (!selectedRow) {
        this.$message.warning('请选择接收客户')
        return
      }
      if (selectedRow.receiveCustomerCode - 0 === this.role.USER_BP - 0) {
        this.errorList = ['货权转移接收客户不能是自己！']
        this.clientDialog = false
        return
      }
      this.transferApplyPo.receiveClientCode = selectedRow.receiveCustomerCode
      this.transferApplyPo.receiveClient = selectedRow.receiveCustomerName
      this.clientDialog = false
    },
    async getFiles() {
      const params = {
        bizId: this.transferApplyPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', this.transferApplyPo.fileBizId || this.transferApplyPo.id)
      formData.append('bizCode', this.processKey)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    // 删除附件
    async delUpload() {
      const check = this.$refs.xTable3.getRadioRecord()
      const index = this.gridOptions2.data.findIndex(v => v._X_ID === check._X_ID)
      await deleteFiles({ id: check.file_id || check.id, isCheck: false })
      this.gridOptions2.data.splice(index, 1)
    },
    validate(cb) {
      this.$refs.form.validate((valid, err) => {
        if (valid) {
          if (this.transferApplyPo.receiveClientCode - 0 === this.role.USER_BP - 0) {
            this.errorList = ['货权转移接收客户不能是自己！']
            return
          } else if (!this.transferApplyPo.receiveClient) {
            this.errorList = ['请选择货权转移客户！']
            return
          }
          cb && cb()
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    saveData() {
      if (this.transferApplyPo.receiveClientCode === '') {
        this.$message.error('请选择货权转移接收客户')
        return
      }
      this.loading = true
      // this.transferApplyPo.stopDeliveryDetailInfoList = this.gridOptions.gridOptions.data
      this.transferApplyPo.attachmentList = this.gridOptions2.data
      const params = JSON.parse(JSON.stringify(this.transferApplyPo))
      console.log(this.transferApplyPo)
      console.log(this.transferApplyPo.attachmentList)
      handlerFlow(params, this.processKey)
        .then(response => {
          this.loading = false
          // alert(response.data.bizId)
          if (!this.transferApplyPo.id) {
            this.startflow(response.data)
          }
          this.$message.success('保存成功')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
    // 提交成功
    advanceSuccess(id) {
      if (id) {
        this.id = id
      }
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/TransferApply.vue